export const getPaginationPoints = (totalElements, resultsPerPage, page) => {
  const currentPageIndex = page + 1
  const start = (currentPageIndex * resultsPerPage) - (resultsPerPage - 1)
  const end = currentPageIndex * resultsPerPage

  return {
    start,
    end: end < totalElements ? end : totalElements,
    totalElements,
  }
}

export const filterResultsPerPage = (list = []) => (totalElements, resultsPerPage, page) => {
  const {start, end} = getPaginationPoints(totalElements, resultsPerPage, page)

  return list.slice(start - 1, end)
}
